import {Component, AfterViewInit, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import 'rxjs/Rx';
import {NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { MatInputModule } from '@angular/material';
import {__moduleName, CanDeactivateGuard} from '../../interfaces';

import { BaseService } from '../../shared/services/base.service';
import { DialogService } from '../../shared/services/dialog.service';
import { FormLabelComponent } from '../../components/form/label/label.component';
import { FormMessageComponent } from '../../components/form/message/message.component';

import { UserUrl } from '../../shared/urls/user.url';
import { Utility } from '../../common/utility';
import { AppConstants } from '../../shared/constants/constants';
import { AppMessages } from '../../shared/constants/messages';
import { ChangePasswordModel } from '../../models/change-password/change-password.model';

@Component({
  moduleId: __moduleName,
  selector: 'change-password',
  templateUrl: 'change-password.component.html'
})

export class ChangePasswordComponent implements OnInit, AfterViewInit {
  public changePassForm: FormGroup;
  public changePasswordModel = new ChangePasswordModel('', '', '');

  constructor(private formBuilder: FormBuilder,
              public utility: Utility,
              private router: Router,
              private baseService: BaseService,
              public dialogService: DialogService) {

  }

  ngOnInit() {
    this.createForm();
  }

  ngAfterViewInit() {

  }

  createForm(){
    this.changePassForm = this.formBuilder.group({
      OldPassword: ['', [Validators.required]],
      NewPassword: ['', [Validators.required, this.isValidNewPassword]],
      ConfirmPassword: ['', [Validators.required, this.isValidRePassword]],
    });
  }

  isValidNewPassword (control: AbstractControl) {
    const group = control.parent;
    if (group) {
      let newPass = group.controls['NewPassword'].value;
      if (group.controls['OldPassword'].value === newPass) {
        return { 'newPassSameOldPass': true };
      }

      let pattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*[!@#$%^&*()_+\d])[A-Za-z\d!@#$%^&*()_+]{8,128}$/;
      if (!pattern.test(newPass)) {
        return { 'invalidPassPolicy': true };
      }
    }
    return null;
  }

  isValidRePassword(control: AbstractControl) {
    const group = control.parent;
    if (group) {
      let rePass = group.controls['ConfirmPassword'].value;
      if (group.controls['NewPassword'].value !== rePass) {
        return { 'newPassNotMatchConfirmPass': true };
      }
    }
    return null;
  }

  resetFormData (ngForm) {
    ngForm.resetForm();
    this.changePassForm.reset();
  }

  onSubmit(ngForm) {
    if (this.changePassForm.dirty && this.changePassForm.valid) {

      // this.dialogService.openErrorDialog({ message: errMsg.message });

      
      // if (!this.pattern.test(newPass)) {
      //   return { 'invalidPassPolicy': true };
      // }

      console.log('success: ' + this.changePassForm.value);
      let url = UserUrl.CHANGE_PASSWORD;
      this.baseService.postData(url, this.changePassForm.value).subscribe(
        (result) => {
          if (result) {
            const data = result.json();
            this.resetFormData(ngForm);
            this.dialogService.openSuccessDialog({message: data.message});
          }
        },
          error => {
        }
      );
    }
  }

}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/change-password/change-password.component.ts